import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../api/firebase";
import { useAuth } from "../../../context/auth";

export function useMileBalance() {
  const { user } = useAuth();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setSummary({ balance: 0, totalEarned: 0 });
      setLoading(false);
      return;
    }

    const ref = doc(db, "users", user.uid, "miles", "summary");
    const unsub = onSnapshot(ref, (snap) => {
      setSummary(snap.exists() ? snap.data() : { balance: 0, totalEarned: 0 });
      setLoading(false);
    });

    return unsub;
  }, [user]);

  return { summary, loading };
}
